import React from "react";

const divStyle = {
  width: "100%",
  height: "100px",
  padding: "10px",
  border: "1px solid darkgray",
  overflowY: "scroll",
  fontSize: "12px",
  backgroundColor: "#e2e2e2"
};

function getCleanPrivacy() {
  const tos = I18n.t("pages.privacy.body_html");
  return tos
    .replace(/<h1>/g, "<p><b>")
    .replace(/<\/h1>/g, "</b></p>")
    .replace(/<h2>/g, "<p><b>")
    .replace(/<\/h2>/g, "</b></p>")
    .replace(/<h3>/g, "<p><b>")
    .replace(/<\/h3>/g, "</b></p>");
}

export default function PrivacyCustomerPreview() {
  return (
    <div>
      <div
        style={divStyle}
        dangerouslySetInnerHTML={{ __html: getCleanPrivacy() }}
      ></div>
    </div>
  );
}
